import {
  buildKindredAuthPath,
  normalizeKindredReturnTo,
} from "../../shared/community/postAuthRedirect";

const POST_AUTH_REDIRECT_KEY = "kindred.post-auth-redirect";

const canUseSessionStorage = () =>
  typeof window !== "undefined" && Boolean(window.sessionStorage);

export const getWebReturnToFromSearch = (search?: string) => {
  const query = new URLSearchParams(
    search ?? (typeof window !== "undefined" ? window.location.search : ""),
  );
  return normalizeKindredReturnTo(query.get("returnTo"));
};

export const rememberWebPostAuthRedirect = (returnTo: string | null | undefined) => {
  const safeReturnTo = normalizeKindredReturnTo(returnTo);
  if (!safeReturnTo || !canUseSessionStorage()) return safeReturnTo;

  window.sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, safeReturnTo);
  return safeReturnTo;
};

export const peekWebPostAuthRedirect = () => {
  if (!canUseSessionStorage()) return null;
  return normalizeKindredReturnTo(window.sessionStorage.getItem(POST_AUTH_REDIRECT_KEY));
};

export const consumeWebPostAuthRedirect = (fallback = "/kinfeed") => {
  const returnTo = peekWebPostAuthRedirect();
  if (canUseSessionStorage()) {
    window.sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
  }
  return returnTo ?? fallback;
};

export const clearWebPostAuthRedirectIfCurrent = (currentPath: string) => {
  const returnTo = peekWebPostAuthRedirect();
  if (returnTo === normalizeKindredReturnTo(currentPath) && canUseSessionStorage()) {
    window.sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
  }
};

export const buildWebAuthPath = (
  authPath: "/signin" | "/signup",
  returnTo: string | null | undefined,
) => buildKindredAuthPath(authPath, returnTo);
